import { ConfigObject } from '../../utils/deviceConfig'
import { apiRequest } from '../../utils/useApi'
import { UpdateDeviceConfigMutationSchema, UpdateDeviceConfigMutationVariablesSchema } from './device_schemas'

export const updateDeviceDiffConfig = async (
    accessToken: string,
    deviceUuid: string,
    diffConfig: ConfigObject,
    timestamp: string
): Promise<void> => {
    const variables = UpdateDeviceConfigMutationVariablesSchema.parse({
        device_uuid: deviceUuid,
        diff_config: diffConfig,
        timestamp
    })
    await apiRequest(
        'POST',
        '/platform/device/update_device_config',
        UpdateDeviceConfigMutationSchema,
        accessToken,
        variables
    )
}
